<template>
  <el-form
    ref="categoryPropsForm"
    :model="categoryProps"
    label-width="0">
    <div class="content-header">
      <div class="title">基本属性</div>
    </div>
    <el-table
      border=""
      :data="categoryProps.baseTemplate">
      <el-table-column
        label="属性名称"
        width="160">
        <template slot-scope="{$index}">
          <el-form-item
            :prop="`baseTemplate.${$index}.cname`"
            :rules="[{required: true, message: '属性名称不能为空', trigger: 'blur'}]">
            <el-input v-model="categoryProps.baseTemplate[$index].cname"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="{row}">
          <el-form-item>{{ propsType[row.type] }}</el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="是否必填">
        <template slot-scope="{row}">
          <el-form-item>
            <el-switch v-model="row.mandatory"></el-switch>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="是否显示">
        <template slot-scope="{row}">
          <el-form-item>
            <el-switch v-model="row.display"></el-switch>
          </el-form-item>
        </template>
      </el-table-column>
      <!-- <el-table-column
        label="H5是否显示"
        width="120">
        <template slot-scope="{row}">
          <el-form-item>
            <el-switch v-model="row.h5Display"></el-switch>
            <el-button
              type="text"
              style="margin-left:5px"
              @click="entSetting(row)">过滤</el-button>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="适用范围"
        width="210">
        <template slot-scope="{row}">
          <el-form-item>
            <el-checkbox-group v-model="row.tradeType">
              <el-checkbox label="FOREIGN">进出口</el-checkbox>
              <el-checkbox label="INLAND">内销</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        width="90">
      </el-table-column>
    </el-table>
    <div class="content-header content-header-extra">
      <div class="title">扩展属性</div>
      <div class="action">
        <el-dropdown
          trigger="click"
          @command="addProps">
          <el-button type="primary">
            添加字段<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in commands"
              :key="index"
              :command="item">{{ item.name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <el-table
      border=""
      :data="categoryProps.extraTemplate">
      <el-table-column
        label="属性名称"
        width="160">
        <template slot-scope="{ $index}">
          <el-form-item
            :prop="`extraTemplate.${$index}.cname`"
            :rules="[{required: true, message: '属性名称不能为空', trigger: 'blur'}]">
            <el-input v-model="categoryProps.extraTemplate[$index].cname"></el-input>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="{row}">
          <el-form-item>{{ propsType[row.type] }}</el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="是否必填">
        <template slot-scope="{row}">
          <el-form-item>
            <el-switch v-model="row.mandatory"></el-switch>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column label="是否显示">
        <template slot-scope="{row}">
          <el-form-item>
            <el-switch v-model="row.display"></el-switch>
          </el-form-item>
        </template>
      </el-table-column>
      <!-- <el-table-column label="H5是否显示">
        <template slot-scope="{row}">
          <el-form-item>
            <el-switch v-model="row.h5Display"></el-switch>
          </el-form-item>
        </template>
      </el-table-column>
      <el-table-column
        label="适用范围"
        width="210">
        <template slot-scope="{row}">
          <el-form-item>
            <el-checkbox-group v-model="row.tradeType">
              <el-checkbox label="FOREIGN">进出口</el-checkbox>
              <el-checkbox label="INLAND">内销</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </template>
      </el-table-column> -->
      <el-table-column
        label="操作"
        width="90">
        <template slot-scope="{row, $index}">
          <el-form-item>
            <el-button
              type="danger"
              @click="deleteProps(row, $index)">删除</el-button>
          </el-form-item>
        </template>
      </el-table-column>
    </el-table>
    <ent-setting-modal ref="modal" />
  </el-form>
</template>

<script>
import clonedeep from 'lodash.clonedeep'
import commands from './commands.js'
import EntSettingModal from './ent-setting-modal.vue'
export default {
  name: 'CategoryProps',
  components: { EntSettingModal },
  props: {
    classId: Number,
    templateType: Number,
    base: {
      type: Array,
      default() {
        return []
      }
    },
    extra: {
      type: Array,
      default() {
        return []
      }
    },
    type: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      categoryProps: {
        baseTemplate: [],
        extraTemplate: []
      },
      commands: commands.commands,
      propsType: commands.propsType
    }
  },
  computed: {

  },
  watch: {
    base: {
      handler(val) {
        this.$set(this.categoryProps, 'baseTemplate', clonedeep(val))
      },
      deep: true,
      immediate: true
    },
    extra: {
      handler(val) {
        const result = clonedeep(val).map(i => {
          i.isFormal = true
          return i
        })
        this.$set(this.categoryProps, 'extraTemplate', result)
      },
      deep: true,
      immediate: true
    }
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.categoryPropsForm.validate(valid => {
          if (valid) {
            resolve({
              ...this.categoryProps,
              type: this.type
            })
          } else {
            const error = {
              type: this.type,
              message: this.name + '信息填写有误，请确认！'
            }
            reject(error)
          }
        })
      })
    },
    deleteProps(row, $index) {
      this.$confirm('是否删除该字段?', '提示', {
        type: 'warning'
      })
        .then(() => {
          this.categoryProps.extraTemplate.splice($index, 1)
        })
        .catch(() => { })
    },
    addProps(command) {
      const props = clonedeep(command.props)
      if (this.categoryProps.extraTemplate.length) {
        const last = this.categoryProps.extraTemplate.length - 1
        const index = +this.categoryProps.extraTemplate[last].name.split('Key')[1]
        props.name = `extraNameKey${index + 1}`
      } else {
        props.name = `extraNameKey0`
      }
      this.categoryProps.extraTemplate.push(props)
    },
    entSetting(row) {
      this.$refs.modal.fetch({
        ...row,
        classId: this.classId,
        templateType: this.templateType
      })
    }
  }
}
</script>
<style lang="stylus" scoped>
.content-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 5px 0;
  font-weight: 700;
}

.content-header-extra {
  margin-top: 10px;
}
</style>
